import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../config/firebase";
import { getCookie } from "./local_storing";

const LOG_COLLECTION = "chatbot_frontend_logs";
const MAX_EVENTS_PER_TYPE_PER_SESSION = 20;

const eventCounts = {};

function getSharedMetadata() {
  const urlParams = new URLSearchParams(window.location.search);
  const shop_id = urlParams.get("parentUrl") || "null";
  const page_url = urlParams.get("currentUrl") || window.location.href;
  const channel = urlParams.get("channel") || "Web";
  const uid = getCookie(shop_id + "uid") || null;

  return {
    shop_id,
    page_url,
    channel,
    uid,
    userAgent: navigator.userAgent,
  };
}

// Writes one error/failure event to the chatbot_frontend_logs Firestore collection; never throws.
export function logError(errorType, error, extraData = {}) {
  try {
    const count = eventCounts[errorType] || 0;
    if (count >= MAX_EVENTS_PER_TYPE_PER_SESSION) return;
    eventCounts[errorType] = count + 1;

    const errorMessage =
      error instanceof Error ? error.message : String(error ?? "");

    addDoc(collection(db, LOG_COLLECTION), {
      ...getSharedMetadata(),
      error_type: errorType,
      error_message: errorMessage,
      ...extraData,
      timestamp: serverTimestamp(),
    }).catch(() => {
      // Swallow write failures - logging must never break the widget.
    });
  } catch (loggingError) {
    // Swallow any synchronous failure in the logger itself.
  }
}
